import { createAction, props } from '@ngrx/store';

export const setGtmEnabled = createAction(
  '[Core:Gtm] Set gtm enabled',
  props<{ isEnabled: boolean }>()
);
